enum EndorsementStatus {
	IN_THE_WORKS = 'In the Works',
	SUBMITTED = 'Submitted',
	APPROVED = 'Approved',
	DECLINED = 'Declined',
	ON_HOLD = 'On Hold',
	CANCELLED = 'Cancelled',
	READY_TO_BIND = 'Ready to Bind',
	UNKNOWN = 'Unknown',
}

export default EndorsementStatus;